export const PREVENT_SCROLL_OFFSET = 50;

export const DELETION_TIMEOUT = 4000;

export const FADE_IN_TIMING = 200;
export const FADE_OUT_TIMING = 200;

export const SCROLL_ANIMATION_TIMING = {
    INSTANT: "0",
    DEFAULT: "0.8",
};

export const DESCRIPTION_TEXT_LENGTH_FOR_OPEN_IN_BOTTOMSHEET = 300;

export const LOCALSTORAGE_ITEMS_AMOUNT_THRESHOLD = 100;

export const DESKTOP_MARGIN_FROM_EDGE = 200;

export const OFFSET_FOR_BOUNCING_ANIMATION = 100;

export const ITEMS_LIST_BOUNCING_ANIMATION_MAX_ITERATION = 2;

// Дополнительное время, на случай каких-то задержек
export const ADDITIONAL_TIME_DELAY_FOR_DELETE_NOT_ALLOWED_CLIP = 200;

export const CLIPSFULLSCREEN_STATE = "clipsFullscreen";
export const INTERSECTION_OBSERVER_THRESHOLDS = {
    /* Считаем, что элемент стал текущим, когда 0.98 потому что:
      * 1) Добавляет плавности ленте, т.к элмент становится текущим немного раньше, чем останавливается
      * анимация свайпа
      * 2) На случай, если где-то вылезли какие-то пиксели
      * */
    COMMON_ITEM: 0.98,

    // Для FullscreenItemType.NOT_ALLOWED 0.5, т.к присутствует анимация
    CLIP_NOT_ALLOWED: 0.5,
};

